import { types, Instance } from 'mobx-state-tree';

export * from './CreditCardBrandModel';
export * from './Labels';
export * from './PaymentMethodModel';
export * from './Payments';
export * from './PayPalExpress';
export * from './StyleCustomizations';
export * from './SiteLimitations';

export const State = types.model({
  Id: types.number,
  Code: types.maybeNull(types.string),
  Name: types.string,
});
export interface IState extends Instance<typeof State> {}

export const Country = types.model({
  Id: types.number,
  Name: types.string,
  States: types.optional(types.array(State), []),
  StateLabel: types.maybeNull(types.string),
  Iso: types.string,
});
export interface ICountry extends Instance<typeof Country> {}

export const AmazonPay = types.model({
  isSandbox: true,
  clientId: types.maybeNull(types.string),
  isEnabled: types.maybeNull(types.boolean),
  sellerId: types.maybeNull(types.string),
});
export interface IAmazonPay extends Instance<typeof AmazonPay> {}

export const StoreLogo = types.model({
  text: types.maybeNull(types.string),
  url: types.maybeNull(types.string),
  publicId: types.maybeNull(types.string),
});
export interface IStoreLogo extends Instance<typeof StoreLogo> {}

export const ReCaptcha = types.model({
  badge: types.maybeNull(types.string),
  checkoutEnabled: types.optional(types.boolean, false),
  hl: types.maybeNull(types.string),
  loginEnabled: types.optional(types.boolean, false),
  siteKey: types.maybeNull(types.string),
  size: types.maybeNull(types.string),
  theme: types.maybeNull(types.string),
});
export interface IReCaptcha extends Instance<typeof ReCaptcha> {}

export const StoreColors = types.model({
  primary: types.optional(types.string, ''),
});
export interface IStoreColors extends Instance<typeof StoreColors> {}

export const StoreFeatures = types.model({
  enableGuestCheckout: types.optional(types.boolean, true),
  disableCustomerLogin: types.optional(types.boolean, false),
  enableOrderComments: types.optional(types.boolean, false),
  enableCompanyNameField: types.optional(types.boolean, false),
  enableEmailOptIn: types.optional(types.boolean, false),
  enableExpressCheckoutCards: types.optional(types.boolean, false),
  enableExpressCheckoutDisplay: types.optional(types.boolean, false),
  enableCoupons: types.optional(types.boolean, false),
  enableGiftCards: types.optional(types.boolean, false),
  enableGiftWrap: types.optional(types.boolean, false),
  requireBillToSameAsShipTo: types.optional(types.boolean, false),
  enableVolusionLogo: types.optional(types.boolean, false),
  enableAddressValidation: types.optional(types.boolean, true),
  enablePayPalPpcp: types.optional(types.boolean, false),
  enableSpreedly: types.optional(types.boolean, false),
  shippingRatesAddressType: types.maybeNull(types.string),
  enableGTM: types.optional(types.boolean, false),
  gtmID: types.maybeNull(types.string),
});
export interface IStoreFeatures extends Instance<typeof StoreFeatures> {}

export const Analytics = types.model({
  googleAnalyticsId: types.maybeNull(types.string),
});
export interface IAnalytics extends Instance<typeof Analytics> {}

export const Messages = types.model({
  shipTo: types.maybeNull(types.string),
  delivery: types.maybeNull(types.string),
  pay: types.maybeNull(types.string),
  oneClick: types.maybeNull(types.string),
  thankYou: types.maybeNull(types.string),
  footer: types.maybeNull(types.string),
});
export interface IMessages extends Instance<typeof Messages> {}
